// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1T6pp","emails":"CreateEditClinics_emails__6_6_s","emailTagLabel":"CreateEditClinics_emailTagLabel__3cyK0"};